import { SelectOption } from '@kanda-libs/ks-component-ts';

export const generateYearsOptions = (): SelectOption[] => {
  const now = new Date();
  const year = now.getFullYear();
  return Array.from(Array(100).keys(), (value: number) => ({
    name: `${year - value}`,
    value: `${year - value}`,
  }));
};

export const getTime = (years?: string, months?: string): number => {
  if (!years || !months) return -1;
  const now = new Date();
  const monthsDiff = now.getMonth() - parseInt(months, 10);
  const yearsDiff = now.getFullYear() - parseInt(years, 10);
  return yearsDiff * 12 + monthsDiff;
};
